module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asiatop10",
    attrs: {
      "id": "asiatop10"
    }
  }, [_c('section', {
    staticClass: "asiatop10-top"
  }, [_vm._m(0), _vm._v(" "), (_vm.screenWidth > 1200) ? _c('img', {
    staticClass: "asiatop10-title",
    attrs: {
      "src": require("../assets/images/asiatop10-title.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "asiatop10-title-m",
    attrs: {
      "src": require("../assets/images/asiatop10-title-m.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "asiatop10-pd-container"
  }, [_c('div', {
    staticClass: "trigger-area"
  }, [(_vm.screenWidth < 1200) ? _c('img', {
    staticClass: "cosmo-logo-asia",
    attrs: {
      "src": require("../assets/images/asiatop10-logo.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.screenWidth > 1200) ? _c('img', {
    staticClass: "asiatop10-pd",
    attrs: {
      "src": require("../assets/images/asiatop10-pd.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "asiatop10-pd-m",
    attrs: {
      "src": require("../assets/images/asiatop10-pd-m.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._l((_vm.asiatop10Product), function(product, index) {
    return _c('div', {
      key: product.no,
      staticClass: "trigger-madal",
      class: 'trigger-madal-item' + index,
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(product)
        }
      }
    }, [_vm._v(" " + _vm._s(product.product) + " ")])
  })], 2)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "modalShownSon": _vm.modalShown,
      "votePageShowPd": _vm.modalPdFlag,
      "imgUrl": _vm.cosmoUrl,
      "sendPage": 'asiatop10'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "bw-logo",
    attrs: {
      "href": "http://www.cosmopolitan.com.tw/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/bw-logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11f51c52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Asiatop10.vue
// module id = 148
// module chunks = 0